export const ANNOUNCEMENT_TIMEOUT = 750;
export const CLEAR_ANNOUNCEMENT_TIMEOUT = 5000;
export const FEEDBACK_ANNOUNCEMENT_TIMEOUT = 1000;